import { DataGrid, LoadPanel } from "devextreme-react";
import {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  Item,
  Scrolling,
  SearchPanel,
  Sorting,
  Toolbar,
} from "devextreme-react/data-grid";
import { divisionOrder } from "../data";
import styled from "styled-components";
import CustomStore from "devextreme/data/custom_store";
import axios from "axios";
import { camelToTitle } from "../utils";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";

const SummaryGridWrapper = styled.div`
  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
  .dx-datagrid-header-panel {
    margin-bottom: 4px;
  }
  .dx-button {
    margin: 0 4px;
  }
  .dx-data-row {
    white-space: pre-wrap;
    word-break: normal;
  }
  .notificationItem {
    table {
      width: 100%;
      table-layout: fixed;
      word-break: break-all;
      height: auto;
      td {
        background-color: #fafafa;
        padding: 8px 16px;
        p {
          margin: 0;
        }
      }
      tr:nth-child(2n) {
        td {
          background-color: white;
        }
      }
    }
    img {
      /* display: block; */
      max-width: 100%;
      height: auto;
    }
  }
`;

const SummaryGrid = ({
  handleClickMenu,
  setYearMonth,
  summaryType,
  yearMonth,
}) => {
  const summaryDataSource = new CustomStore({
    key: "contrNo",
    load: async () => {
      //! api GET R23. Get the summary of study status, R24. Get the summary of issues
      const response = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/mthlyReport/sum/${summaryType}/${yearMonth}`
      );
      return response.data;
    },
  });

  const extractTextFromHTML = (htmlString) => {
    const htmlCode = htmlString.split("\n- ")[1];
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlCode, "text/html");
    let result = [];

    // 깊이에 따른 리스트 카운터 관리
    const listCounters = [];

    function processNode(node, depth = 0) {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.nodeValue.trim();
        if (text) {
          result.push(text);
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        if (
          node.tagName.toLowerCase() === "ol" ||
          node.tagName.toLowerCase() === "ul"
        ) {
          listCounters.push({ type: node.tagName.toLowerCase(), count: 0 });
        }
        if (["p", "li"].includes(node.tagName.toLowerCase())) {
          result.push("\n" + " ".repeat(depth * 2));
        }
        switch (node.tagName.toLowerCase()) {
          case "p":
          case "ol":
          case "ul":
            Array.from(node.childNodes).forEach((child) =>
              processNode(child, depth + 1)
            );
            // ol, ul 태그 끝에 추가적인 줄바꿈 처리가 필요 없으면 이 부분은 제거
            // result.push("\n");
            break;
          case "li":
            let prefix = "";
            if (listCounters.length > 0) {
              const currentList = listCounters[listCounters.length - 1];
              currentList.count++;
              prefix =
                currentList.type === "ol" ? `${currentList.count}. ` : "- ";
            }
            result.push(" ".repeat(depth * 2) + prefix);
            Array.from(node.childNodes).forEach((child) =>
              processNode(child, depth)
            );
            // result.push("\n"); // li 태그 끝에 줄바꿈 추가
            break;
          default:
            Array.from(node.childNodes).forEach((child) =>
              processNode(child, depth)
            );
            break;
        }

        if (
          node.tagName.toLowerCase() === "ol" ||
          node.tagName.toLowerCase() === "ul"
        ) {
          listCounters.pop();
        }
      }
    }

    Array.from(doc.body.childNodes).forEach((node) => processNode(node, 0));
    return result.join("").trim(); // 마지막의 공백 제거
  };

  const handleCalculateSortValue = (e) => {
    return e.sortOrder;
  };
  const handleCellStyle = (e) => {
    if (e.rowType === "header") {
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.verticalAlign = "middle";
      e.cellElement.style.fontWeight = "bold";
    }
  };

  const handleChangeYearMonth = (e) => {
    const [year, month] = e.value.split("/");
    setYearMonth(`${year}-${month}`);
  };

  const handleColumnSorting = (e) => {
    if (summaryType === "studyStatus") {
      e.component.columnOption("contractNo", "sortOrder", "asc");
    } else {
      e.component.columnOption("status", {
        sortOrder: "asc",
        sortIndex: 0,
      });
      e.component.columnOption("dateIdentified", {
        sortOrder: "desc",
        sortIndex: 1,
      });
    }
  };

  const handleClickRepBtn = () => {
    handleClickMenu("report", false);
  };

  const handleExportExcel = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(`${yearMonth}`);
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell.rowType === "data") {
          if (gridCell.column.dataField === "OFStudyStatus" && gridCell.value) {
            excelCell.value = extractTextFromHTML(gridCell.value);
          }
        }
        if (gridCell.rowType === "header") {
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "BEDFE6" },
          };
        }
      },
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          `Summary_${camelToTitle(summaryType)}_${yearMonth}.xlsx`
        );
      });
    });
    e.cancel = true;
  };

  return (
    <SummaryGridWrapper>
      <DataGrid
        allowColumnResizing={true}
        columnResizingMode={"nextColumn"}
        dataSource={summaryDataSource}
        height={"calc(100vh - 220px)"}
        id={`${summaryType}Grid`}
        onCellPrepared={handleCellStyle}
        onContentReady={handleColumnSorting}
        onExporting={handleExportExcel}
        showBorders={true}
        showColumnHeaders={true}
        showColumnLines={true}
        wordWrapEnabled={true}
      >
        <Export enabled={true} />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <LoadPanel enabled={true} />
        <Scrolling mode="virtual" showScrollbar={"always"} />
        <SearchPanel placeholder="Search..." visible={true} width={200} />
        <Sorting mode="multiple" />
        <Toolbar>
          <Item
            name="yearMonthDateBox"
            location="before"
            options={{
              calendarOptions: {
                maxZoomLevel: "year",
                minZoomLevel: "decade",
                zoomLevel: "year",
              },
              displayFormat: "yyyy년 M월",
              onValueChanged: handleChangeYearMonth,
              pickerType: "calendar",
              type: "date",
              value: yearMonth,
            }}
            widget="dxDateBox"
          />
          <Item
            location="after"
            name="navReportButton"
            options={{
              onClick: handleClickRepBtn,
              stylingMode: "contained",
              text: "REPORT",
              type: "success",
            }}
            widget="dxButton"
          />
          <Item name="exportButton" location="after" />
          <Item name="searchPanel" location="after" />
        </Toolbar>
        <Column
          alignment="center"
          caption="Contract No."
          dataField="contrNo"
          width={130}
        />
        <Column
          alignment="center"
          caption="Priority"
          dataField="prio"
          visible={summaryType === "studyStatus"}
          width={110}
        />
        <Column
          alignment="left"
          caption="Sponsor Name, Project Name, Type"
          dataField="projectName"
          visible={summaryType === "studyStatus"}
          width={150}
        />
        <Column
          alignment="left"
          allowHeaderFiltering={false}
          allowSorting={false}
          caption="Assigned List"
          dataField="prjAsgmt"
          visible={summaryType === "studyStatus"}
          width={220}
        />
        <Column
          alignment="left"
          allowHeaderFiltering={false}
          allowSorting={false}
          caption="Timeline"
          dataField="tl"
          visible={summaryType === "studyStatus"}
          width={200}
        />
        <Column
          alignment="left"
          allowHeaderFiltering={false}
          allowSorting={false}
          caption="Enrollment Status"
          dataField="enrollStatus"
          visible={summaryType === "studyStatus"}
          width={200}
        />
        <Column
          caption="Projet Status, Action Plan"
          visible={summaryType === "studyStatus"}
        >
          {divisionOrder.map((division, idx) => {
            return division !== "OF" ? (
              <Column
                key={idx}
                alignment="left"
                allowHeaderFiltering={false}
                allowSorting={false}
                caption={division}
                dataField={`${division}StudyStatus`}
                width={250}
              />
            ) : (
              ""
            );
          })}
        </Column>
        <Column caption="Notification" visible={summaryType === "studyStatus"}>
          <Column
            alignment="left"
            allowHeaderFiltering={false}
            allowSorting={false}
            caption="OF"
            customizeText={(e) => (e.value ? extractTextFromHTML(e.value) : "")}
            cssClass="notificationItem"
            dataField="OFStudyStatus"
            width={250}
          />
        </Column>
        <Column
          alignment="center"
          caption="Id"
          dataField="id"
          visible={summaryType === "issue"}
          width={70}
        />
        <Column
          alignment="center"
          calculateSortValue={handleCalculateSortValue}
          caption="Status"
          dataField="statName"
          sortIndex={0}
          visible={summaryType === "issue"}
          width={100}
        />
        <Column
          alignment="center"
          caption="Grade"
          dataField="gradName"
          visible={summaryType === "issue"}
          width={100}
        />
        <Column
          alignment="center"
          caption="Internal Share"
          dataField="intShr"
          visible={summaryType === "issue"}
          width={120}
        />
        <Column
          alignment="center"
          caption="Type"
          dataField="typeName"
          visible={summaryType === "issue"}
          width={100}
        />
        <Column
          alignment="left"
          caption="Issue Description"
          dataField="issDescr"
          visible={summaryType === "issue"}
          width={200}
        />
        <Column
          alignment="center"
          calculateCellValue={(e) => `${e.oEmployeeName} (${e.oEmployeeNo})`}
          caption="Owner"
          visible={summaryType === "issue"}
          width={120}
        />
        <Column
          alignment="center"
          caption="Date Identified"
          dataField="iDate"
          dataType="date"
          editorOptions={{
            dateSerializationFormat: "yyyy-MM-dd",
          }}
          format="yyyy-MM-dd"
          sortIndex={1}
          sortOrder="desc"
          visible={summaryType === "issue"}
          width={150}
        />
        <Column
          alignment="center"
          caption="Associated Id"
          dataField="assocdId"
          visible={summaryType === "issue"}
          width={140}
        />
        <Column
          alignment="center"
          caption="Entered By"
          calculateCellValue={(e) => `${e.eBEmployeeName} (${e.eBEmployeeNo})`}
          visible={summaryType === "issue"}
          width={120}
        />
        <Column
          alignment="left"
          caption="Root Cause"
          dataField="rootCuz"
          visible={summaryType === "issue"}
          width={250}
        />
        <Column
          alignment="left"
          caption="Impact Summary"
          dataField="iSum"
          visible={summaryType === "issue"}
          width={250}
        />
        <Column
          alignment="left"
          caption="Action"
          dataField="ac"
          visible={summaryType === "issue"}
          width={250}
        />
        <Column
          alignment="center"
          caption="Expected Resolution Date"
          dataField="expResDate"
          visible={summaryType === "issue"}
          width={150}
        />
        <Column
          alignment="center"
          caption="Actual Resolution Date"
          dataField="actResDate"
          visible={summaryType === "issue"}
          width={150}
        />
        <Column
          alignment="left"
          caption="Final Resolution & Rationale"
          dataField="fResR"
          visible={summaryType === "issue"}
          width={250}
        />
      </DataGrid>
    </SummaryGridWrapper>
  );
};

export default SummaryGrid;
